import { queryOptions } from "@tanstack/react-query";
import { qk } from "@/lib/query-keys";
import { estado2FA } from "@/shared/api/auth.api";

/**
 * queryOptions del estado del segundo factor · compartido entre el `loader`
 * de `/perfil` (precarga) y `SeccionDosFactores` (render). `staleTime`
 * generoso: el estado del 2FA casi nunca cambia dentro de una sesión, así
 * que tras la precarga la caché lo sirve al instante y el bloque deja de
 * aparecer "en blanco" mientras viaja la primera consulta.
 */
export const seguridad2FAQueryOptions = queryOptions({
  queryKey: qk.seguridad2FA,
  queryFn: estado2FA,
  staleTime: 5 * 60_000,
});
